import {Action, configureStore, ThunkAction} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/dist/query';
import authApi from '../redux/auth.api';
import gftRootApi from '../redux/gft-root.api';
import investmentsApi from '../redux/investments.api';
import projectsApi from '../redux/projects.api';
import signerApi from '../redux/signer.api';
import solutionContractApi from '../redux/solution-contract.api';
import tokenContractApi from '../redux/token-contract.api';
import userSlice from '../redux/user.slice';
import walletReducer from '../redux/wallet.slice';

export const store = configureStore({
  reducer: {
    // [pokemonApi.reducerPath]: pokemonApi.reducer,
    [tokenContractApi.reducerPath]: tokenContractApi.reducer,
    // [referrerReferralApi.reducerPath]: referrerReferralApi.reducer,
    // [refererApi.reducerPath]: refererApi.reducer,
    [solutionContractApi.reducerPath]: solutionContractApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [signerApi.reducerPath]: signerApi.reducer,
    [projectsApi.reducerPath]: projectsApi.reducer,
    [investmentsApi.reducerPath]: investmentsApi.reducer,
    [gftRootApi.reducerPath]: gftRootApi.reducer,
    wallet: walletReducer,
    user: userSlice,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(
      tokenContractApi.middleware,
      // referrerReferralApi.middleware,
      // refererApi.middleware,
      solutionContractApi.middleware,
      authApi.middleware,
      signerApi.middleware,
      projectsApi.middleware,
      investmentsApi.middleware,
      gftRootApi.middleware,
    ),
  // .concat(pokemonApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

setupListeners(store.dispatch);
